<template>
  <div class="pa-3">
    <v-row>
      <v-col md="3">
        <v-card height="321" elevation="0" class="text-center pa-5">
          <v-badge overlap color="teal">
            <template v-slot:badge>
              <span>在职</span>
            </template>
            <v-avatar size="100">
              <img :src="$store.state.userInfo.avatar || require('@/assets/def-head.jpeg')">
            </v-avatar>
          </v-badge>
          <v-card-text>
            <div class="font-weight-bold size-18">{{$store.state.userInfo.name}}</div>
            <div class="my-1 size-13 grey--text">{{$store.state.userInfo.email || '未填写邮箱'}}</div>
            <div>
              <v-toolbar dark elevation="0" class="self-center">
                <v-row>
                  <v-col class="justify-space-between">
                    <span class="font-weight-bold size-12">入职</span><br>
                    <span class="font-weight-bold size-17">{{$store.state.userInfo.entryTime === null ? '--' : (parseInt(($moment(new Date()).unix() - $store.state.userInfo.entryTime) / 3600 / 24))}}天</span>
                  </v-col>
                  <v-divider class="mx-0" vertical></v-divider>
                  <v-col class="justify-start">
                    <span class="font-weight-bold size-12">工号</span><br>
                    <span class="font-weight-bold size-17">{{$store.state.userInfo.jobNumber || '--'}}</span>
                  </v-col>
                </v-row>
              </v-toolbar>
            </div>
            <div class="my-4">
              <v-btn outlined :color="$store.state.userInfo.formalStatus === 1 ? 'grey' : 'primary'" text block rounded :disabled="$store.state.userInfo.formalStatus === 1" @click="showFormalApply = { show: true }">
                {{$store.state.userInfo.formalStatus === 1 ? '已转正' : '申请转正'}}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9">
        <v-card class="pa-3 mb-2 rounded-lg" elevation="0">
          <v-row>
            <v-col cols="12" md="2">
              <v-select
                hide-details
                outlined dense
                label="年份选择"
                :items='yearItems'
                @change="init"
                item-text="label"
                item-value="value"
                v-model='form.year'>
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                hide-details
                outlined dense
                label="月份选择"
                :items="monthItems"
                @change="init"
                item-text="label"
                item-value="value"
                v-model='form.month'>
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn :loading="loading" class="mt-c-3 px-1" color="primary" @click="init">查询</v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card elevation="0" class="my-3 grey lighten-4">
          <v-row>
            <v-col cols="12" md="3">
              <v-card elevation="0" class="teal accent-4" rounded="lg">
                <v-card-subtitle class="size-15 font-weight-bold white--text pb-5">出勤工资
                  <div class="float-right">
                    <v-btn @click="clockInModal = { show: true, data: form }" small dark rounded depressed class="mt-n1" color="teal">{{personalCount.workedDay}}天</v-btn>
                  </div>
                </v-card-subtitle>
                <v-card-text class="size-25 font-weight-bold white--text">
                  ¥ {{personalCount.workSalary || 0}}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="text-left">
              <v-card elevation="0" class="cyan accent-4" rounded="lg">
                <v-card-subtitle class="size-15 font-weight-bold white--text pb-5">提成/绩效</v-card-subtitle>
                <v-card-text class="size-25 font-weight-bold white--text">
                  ¥ {{personalCount.commissionSalary || 0}}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="text-left">
              <v-card elevation="0" class="light-blue accent-3" rounded="lg">
                <v-card-subtitle class="size-15 font-weight-bold white--text pb-5">餐补</v-card-subtitle>
                <v-card-text class="size-25 font-weight-bold white--text">
                  ¥ {{personalCount.otherWelfare || 0}}
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="text-left">
              <v-card elevation="0" class="deep-purple lighten-2" rounded="lg">
                <v-card-subtitle class="size-15 font-weight-bold white--text pb-5">应发薪资</v-card-subtitle>
                <v-card-text class="size-25 font-weight-bold white--text">
                  ¥ {{ (personalCount.shouldSalary)}}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-card height="135" elevation="0" class="text-center py-4 px-3">
          <v-row>
            <v-col cols="12" md="3" class="text-left pb-0">
              <span :class="labelClass">
                <v-tooltip top open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" x-small class="mt-n1">
                      <v-icon color="grey lighten-1">
                        mdi-alert-circle-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    <p>请假：{{personalCount.leaveDeduct || 0}}元</p>
                    <p>迟到：{{personalCount.lateDeduct || 0}}元</p>
                    <p>缺卡：{{personalCount.missingDeduct || 0}}元</p>
                    <p>汇报：{{personalCount.reportDeduct || 0}}元</p>
                    <p>通话：{{personalCount.callDeduct || 0}}元</p>
                  </span>
                </v-tooltip>
                乐捐
              </span>
              <span :class="valueClass">{{(personalCount.reportDeduct + personalCount.leaveDeduct + personalCount.lateDeduct + personalCount.callDeduct + personalCount.otherDeduct).toFixed(2)}}元</span>
              <v-divider :class="dividerClass"></v-divider>
            </v-col>
            <v-col cols="12" md="3" class="text-left pb-0">
              <span :class="labelClass">社保扣除</span>
              <span :class="valueClass">{{personalCount.socialSecurityDeduct || 0}}元</span>
              <v-divider :class="dividerClass"></v-divider>
            </v-col>
            <v-col cols="12" md="3" class="text-left pb-0">
              <span :class="labelClass">个税扣除</span>
              <span :class="valueClass">{{personalCount.selfTaxDeduct || 0}}元</span>
              <v-divider :class="dividerClass"></v-divider>
            </v-col>
            <v-col cols="12" md="3" class="text-left pb-0">
              <span class="font-weight-bold size-15 red--text">实发薪资</span>
              <span :class="valueClass">{{personalCount.actualSalary || 0}}元</span>
              <v-divider :class="dividerClass"></v-divider>
            </v-col>
          </v-row>
          <v-row cols="12" >
            <v-col class="text-left pt-1">
              <p class="size-12">
                <v-chip label x-small color="primary" dark class="pa-1 mt-n1 mr-2">1</v-chip>
                实发薪资 = 应发薪资 - 乐捐 - 社保扣除 - 个税扣除
              </p>
              <p class="size-12 mt-n1">
                <v-chip label x-small color="primary" dark class="pa-1 mt-n1 mr-2">2</v-chip>
                出勤工资、乐捐（每日早上9:00计算，一天延迟）餐补、提成/绩效、社保扣除、个税扣除、实发薪资（每月工资发放前计算）
              </p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-row>
        <v-col cols="12" md="2" v-for="(item, idx) in checkWorks" :key='idx'>
          <v-card elevation="0" rounded="1" :loading="loading">
            <v-list-item two-line>
              <v-list-item-content>
                <div class="mb-2 size-18">
                  {{item.value < 0 ? 0 : item.value}}
                </div>
                <v-list-item-title class="grey--text size-14">
                  {{item.title}}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                size="50"
              > <v-icon :color="item.color">{{item.icon}}</v-icon> </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="white my-3 rounded-lg">
      <v-row>
        <v-col cols="12" md="3">
          <v-card max-width="300" elevation="0" :loading="loading" class="text-center px-5 mr-5">
            <v-progress-circular
              :rotate="360"
              :size="165"
              :width="10"
              :value="allScore"
              color="teal"
            >
            {{ allScore.toFixed(2) }}分
            </v-progress-circular>
            <p class="grey--text mt-2">综合评分</p>
          </v-card>
        </v-col>
        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="3" v-for="(item, idx) in scores" :key="idx" class="pb-0">
              <v-card elevation="0">
                <span>
                  <span class="ml-2 size-12">{{item.title}}</span>
                    <v-rating background-color="primary accent-4"
                      color="primary"
                      readonly
                      v-model="item.value"
                    ></v-rating>
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <formal-apply :item="showFormalApply"></formal-apply>
    <clock-in :item="clockInModal"></clock-in>
  </div>
</template>

<script>

  import { salary } from '@/api/home.js'
  import { byUid } from '@/api/office/score.js'
  import { workByUid } from '@/api/office/checkwork.js'
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import FormalApply from './components/FormalApply.vue'
  import ClockIn from './components/ClockInDetail.vue'

  export default {
    name: 'PersonalIndex',
    components: {
      FormalApply,
      ClockIn
    },
    data() {
      return {
        tab1: 0,
        tab2: 0,
        rating: 4.5,
        expandOnHover: false,
        showMore: true,
        loading: false,
        clockInModal: { show: false },
        showFormalApply: { show: false },
        dividerClass: 'my-2 border-1 rounded-lg blue-grey lighten-5',
        labelClass: 'font-weight-bold size-15 blue-grey--text text--lighten-2',
        valueClass: 'font-weight-bold size-15 float-right mt-1',
        today: this.$moment().format('YYYY-MM-DD'),
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        form: {
          month: Number(this.$moment().format('MM')),
          year: Number(this.$moment().format('YYYY'))
        },
        personalCount: {},
        scores: [],
        checkWorks: [],
        allScore: 0
      }
    },
    methods: {
      personal () {
        this.loading = true
        salary(this.form).then(res => {
          if (res.status === 200) {
            this.personalCount = res.data || {}
          }
          this.loading = false
        })
      },
      score () {
        byUid(this.form).then(res => {
          if (res.status === 200) {
            const { data } = res
            this.allScore = data.allScore || 0
            this.scores = [
              { title: '业绩(15分)', value: data.achievementScore / 15 * 5 || 0 },
              { title: '回款(20分)', value: data.returnedScore / 20 * 5 || 0 },
              { title: '首付款(10分)', value: data.firstReturnedScore / 10 * 5 || 0 },
              { title: '客户跟进(15分)', value: data.customerScore / 15 * 5 || 0 },
              { title: '客户服务(10分)', value: data.serviceScore / 10 * 5 || 0 },
              { title: '专业度(5分)', value: data.professionScore / 5 * 5 || 0 },
              { title: '团队协作(5分)', value: data.teamScore / 5 * 5 || 0 },
              { title: '创新能力(5分)', value: data.innovateScore / 5 * 5 || 0 },
              { title: '考勤(10分)', value: data.checkWorkScore / 10 * 5 || 0 },
              { title: '汇报(6分)', value: data.reportScore / 6 * 5 || 0 },
              { title: '乐捐(4分)', value: data.penaltyScore / 4 * 5 || 0 },
            ]
          }
        })
      },
      workByUid () {
        workByUid(this.form).then(res => {
          if (res.status === 200) {
            const { data } = res
            this.checkWorks = [
              { title: '请假时长(天)', icon: 'mdi-lead-pencil', color: 'red', value: data.travelDuration || 0 },
              { title: '出差时长(天)', icon: 'mdi-vimeo', color: 'purple', value: data.businessDuration || 0 },
              { title: '迟到次数', icon: 'mdi-white-balance-sunny', color: 'blue', value: data.lateCount || 0 },
              { title: '加班时长(h)', icon: 'mdi-presentation', color: 'cyan', value: data.otDuration || 0 },
              { title: '汇报未写(次)', icon: 'mdi-atlassian', color: 'teal', value: data.reportLack || 0 },
              { title: '通话缺少(个)', icon: 'mdi-cellphone-sound', color: 'amber', value: data.callLack || 0 }
            ]
          }
        })
      },
      init () {
        this.personal()
        this.score()
        this.workByUid()
      }
    },
    created () {
      this.init()
    }
  }
</script>
<style scoped>
.self-center {
  background:linear-gradient( to right,#4cbde3,#4cbde3,#5c99e6)
}
</style>